export const baseUrl =
  process.env.REACT_APP_JOOR_URL || "https://www.joor.local";

const createAbsolutePath = (relativePath: String) => baseUrl + relativePath;

export default createAbsolutePath;
